function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import axios from "axios";
import { joinURL } from "~/map-interface/utils";
import { SETTINGS } from "../../settings";
export var base = "".concat(SETTINGS.apiDomain, "/api/v2");
var basev1 = "".concat(SETTINGS.gddDomain, "/api/v1");
var pbdbURL = "".concat(SETTINGS.pbdbDomain, "/data1.2/colls/list.json");
var pbdbURLOccs = "".concat(SETTINGS.pbdbDomain, "/data1.2/occs/list.json");

function formColumnQueryString(filters) {
  var possibleFields = {
    intervals: ["int_id", "id"],
    // [value, attr]
    strat_name_concepts: ["strat_name_concept_id", "id"],
    strat_name_orphans: ["strat_name_id", "id"],
    lithology_classes: ["lith_class", "name"],
    lithology_types: ["lith_type", "name"],
    lithologies: ["lith_id", "id"],
    // These cases weren't handled in v3, hopefully adding
    // them here does not cause new problems...
    all_lithology_classes: ["lith_class", "name"],
    all_lithology_types: ["lith_type", "name"],
    all_lithologies: ["lith_id", "id"],
    // Environments are unused for now in map filtering, but used in
    // column filtering (I think)
    environments: ["environ_id", "id"],
    environment_types: ["environ_type", "name"],
    environment_classes: ["environ_class", "name"]
  };
  var query = {};
  filters.forEach(function (f) {
    var _possibleFields$f$typ = _slicedToArray(possibleFields[f.type], 2),
        value = _possibleFields$f$typ[0],
        attr = _possibleFields$f$typ[1];

    if (query[value]) {
      query[value].push(f[attr]);
    } else {
      query[value] = [f[attr]];
    }
  });
  var queryString = Object.keys(query).map(function (k) {
    return "".concat(k, "=").concat(query[k].join(","));
  }).join("&");
  return queryString;
}

export function fetchFilteredColumns(_x) {
  return _fetchFilteredColumns.apply(this, arguments);
}

function _fetchFilteredColumns() {
  _fetchFilteredColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(providedFilters) {
    var queryString, url, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryString = formColumnQueryString(providedFilters);
            url = "".concat(base, "/columns?format=geojson_bare&").concat(queryString);
            _context2.next = 4;
            return axios.get(url, {
              responseType: "json"
            });

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchFilteredColumns.apply(this, arguments);
}

export function handleXDDQuery(_x2, _x3) {
  return _handleXDDQuery.apply(this, arguments);
}

function _handleXDDQuery() {
  _handleXDDQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(mapInfo, cancelToken) {
    var stratNames, url, res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!mapInfo || !mapInfo.mapData.length || Object.keys(mapInfo.mapData[0].macrostrat).length === 0)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", []);

          case 2:
            stratNames = mapInfo.mapData[0].macrostrat.strat_names.map(function (d) {
              return d.rank_name;
            }).join(",");
            url = "".concat(basev1, "/snippets");
            _context3.next = 6;
            return axios.get(url, {
              params: {
                article_limit: 20,
                term: stratNames
              },
              cancelToken: cancelToken,
              responseType: "json"
            });

          case 6:
            res = _context3.sent;
            _context3.prev = 7;
            return _context3.abrupt("return", res.data.success.data);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](7);
            return _context3.abrupt("return", []);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[7, 11]]);
  }));
  return _handleXDDQuery.apply(this, arguments);
}

function addMapIdToRef(data) {
  data.success.data.mapData = data.success.data.mapData.map(function (source) {
    source.ref.map_id = source.map_id;
    return source;
  });
  return data;
}

export function fetchAllColumns() {
  return _fetchAllColumns.apply(this, arguments);
}

function _fetchAllColumns() {
  _fetchAllColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var res;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.get(joinURL(base, "columns"), {
              responseType: "json",
              params: {
                format: "geojson_bare",
                all: true
              }
            });

          case 2:
            res = _context4.sent;
            return _context4.abrupt("return", res.data.features);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchAllColumns.apply(this, arguments);
}

export function runMapQuery(_x4, _x5, _x6, _x7, _x8) {
  return _runMapQuery.apply(this, arguments);
}

function _runMapQuery() {
  _runMapQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(lng, lat, z, map_id, cancelToken) {
    var params, url, res, data;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            params = {
              lng: lng,
              lat: lat,
              z: z,
              map_id: map_id
            };
            url = base + "/mobile/map_query_v2";
            _context5.next = 4;
            return axios.get(url, {
              cancelToken: cancelToken,
              responseType: "json",
              params: params
            });

          case 4:
            res = _context5.sent;
            data = addMapIdToRef(res.data).success.data; // if (data.hasColumns) {
            //   // TODO: fix this...
            //   // Somewhat ridiculously, we need to run a separate query to get the
            //   // column ID, because the map query doesn't return it.
            //   // This needs to get a lot better.
            //   const pointData = await axios.get(base + "/mobile/point", {
            //     params: {
            //       lng,
            //       lat,
            //       z,
            //     },
            //   });
            //   const col_id = pointData.data.success.data.col_id;
            //   data.col_id = col_id;
            // }

            return _context5.abrupt("return", data);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _runMapQuery.apply(this, arguments);
}

export function runColumnQuery(_x9, _x10) {
  return _runColumnQuery.apply(this, arguments);
}

function _runColumnQuery() {
  _runColumnQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(column, cancelToken) {
    var res;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.get(base + "/units", {
              cancelToken: cancelToken,
              responseType: "json",
              params: {
                response: "long",
                col_id: column.col_id
              }
            });

          case 2:
            res = _context6.sent;
            _context6.prev = 3;
            return _context6.abrupt("return", res.data.success.data);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](3);
            return _context6.abrupt("return", []);

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[3, 7]]);
  }));
  return _runColumnQuery.apply(this, arguments);
}

export var asyncGetElevation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(line, cancelToken) {
    var _line$, start_lng, start_lat, _line$2, end_lng, end_lat, params, url, res, data;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _line$ = _slicedToArray(line[0], 2), start_lng = _line$[0], start_lat = _line$[1];
            _line$2 = _slicedToArray(line[1], 2), end_lng = _line$2[0], end_lat = _line$2[1];
            params = {
              start_lng: start_lng,
              start_lat: start_lat,
              end_lng: end_lng,
              end_lat: end_lat
            };
            url = "".concat(base, "/elevation");
            _context.next = 6;
            return axios.get(url, {
              //cancelToken,
              responseType: "json",
              params: params
            });

          case 6:
            res = _context.sent;
            data = res.data;
            _context.prev = 8;
            return _context.abrupt("return", data.success.data);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](8);
            return _context.abrupt("return", []);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 12]]);
  }));

  return function asyncGetElevation(_x11, _x12) {
    return _ref.apply(this, arguments);
  };
}();
/* PBDB data */
// use new cancellation API

var abortController = null;
export function getPBDBData(_x13) {
  return _getPBDBData.apply(this, arguments);
}

function _getPBDBData() {
  _getPBDBData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(collections) {
    var _abortController;

    var coll_id, opts;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            (_abortController = abortController) === null || _abortController === void 0 ? void 0 : _abortController.abort();
            abortController = new AbortController();
            coll_id = collections.join(",");
            opts = {
              responseType: "json",
              signal: abortController.signal
            };
            return _context7.abrupt("return", Promise.all([axios.get(pbdbURL, _objectSpread(_objectSpread({}, opts), {}, {
              params: {
                id: coll_id,
                show: "ref,time,strat,geo,lith,entname,prot",
                markrefs: true
              }
            })), axios.get(pbdbURLOccs, _objectSpread(_objectSpread({}, opts), {}, {
              params: {
                coll_id: coll_id,
                show: "phylo,ident"
              }
            }))]).then(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  collections = _ref3[0],
                  occurences = _ref3[1];

              return mergePBDBResponses(collections, occurences);
            })["finally"](function () {
              abortController = null;
            }));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getPBDBData.apply(this, arguments);
}

function mergePBDBResponses(collectionResponse, occurrenceResponse) {
  try {
    var occurrences = occurrenceResponse.data.records;
    return collectionResponse.data.records.map(function (col) {
      col.occurrences = [];
      occurrences.forEach(function (occ) {
        if (occ.cid === col.oid) {
          col.occurrences.push(occ);
        }
      });
      return col;
    });
  } catch (error) {
    console.log(error);
    return [];
  }
}